import { jsx } from "react/jsx-runtime";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { validateTidalLicense } from "../../base/index.js";
function MailOutline(props) {
  return /* @__PURE__ */ jsx(
    MailOutlineIcon,
    {
      "data-testid": "MailOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MailOutline",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
MailOutline.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "MailOutline"
};
validateTidalLicense();
export {
  MailOutline
};
//# sourceMappingURL=MailOutline.js.map
